// extracted by mini-css-extract-plugin
export default {"root_svg":"root_svg___bvCad","pointer":"pointer___Mruui","svg":"svg___mtQi1"};